import { ArrowDown } from "lucide-react";
import { CABANAS } from "@/data/cabanas";

export const Hero = () => {
  const heroImage = CABANAS[1].images[0]; // Domo image as hero

  return (
    <section
      data-testid="hero-section"
      className="relative w-full h-[90vh] min-h-[640px] flex items-end overflow-hidden grain"
    >
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0E1714]/90 via-[#0E1714]/40 to-[#0E1714]/20 z-10" />

      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 lg:px-8 pb-20 lg:pb-28 fade-up">
        <span
          data-testid="hero-eyebrow"
          className="inline-flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#F9F6F0]/90 mb-6"
        >
          <span className="w-8 h-px bg-[#C05A44]" />
          São José dos Pinhais · Paraná
        </span>

        <h1
          data-testid="hero-title"
          className="text-[#F9F6F0] text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] font-black leading-[0.95] tracking-tighter max-w-4xl"
        >
          Um refúgio rural<br />em meio aos morangais.
        </h1>

        <p
          data-testid="hero-subtitle"
          className="mt-8 text-[#F9F6F0]/85 text-lg lg:text-xl max-w-xl leading-relaxed"
        >
          Seis cabanas autorais, parrilla argentina exclusiva, hidromassagem,
          café da manhã e jantar inclusos. A 30 km de Curitiba.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <a
            href="#cabanas"
            data-testid="hero-cta-cabanas"
            className="inline-flex items-center justify-center h-14 px-8 bg-[#F9F6F0] text-[#1A2421] font-bold text-sm uppercase tracking-[0.15em] hover:bg-[#C05A44] hover:text-white transition-colors"
          >
            Conhecer as cabanas
          </a>
          <a
            href="#experiencia"
            data-testid="hero-cta-experiencia"
            className="inline-flex items-center justify-center gap-2 h-14 px-8 border border-[#F9F6F0]/40 text-[#F9F6F0] font-bold text-sm uppercase tracking-[0.15em] hover:border-[#F9F6F0] transition-colors"
          >
            A experiência
            <ArrowDown size={16} strokeWidth={1.8} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
